export const menuData = {
  offers: {
    id: 'offers',
    name: 'Offers',
    description: 'Special package deals and promotions',
    items: [
      {
        name: 'Bols Vodca 700ml + 4 buc. Coca-Cola 250ml SAU Nectar (portocale/ mere/ cranberry) 1000ml',
        price: '242 RON',
        description: 'Premium vodka package with mixers'
      },
      {
        name: 'Bols Vodca 700ml + 4 buc. Red Bull 250ml',
        price: '250 RON',
        description: 'Premium vodka package with mixers'
      },
      {
        name: 'Russian Standard 700 ml + 4 buc Coca-Cola 250 ml SAU Nectar (portocale/mere/cranberry) 1000 ml',
        price: '242 RON',
        description: 'Premium vodka package with mixers'
      },
      {
        name: 'Russian Standard 700 ml + 4 buc Red Bull 250 ml',
        price: '250 RON',
        description: 'Premium vodka package with mixers'
      },
      {
        name: 'Grey Goose 700ml + 4 buc. Coca-Cola 250ml SAU Nectar (portocale/ mere/ cranberry) 1000ml',
        price: '650 RON',
        description: 'Luxury vodka package with mixers'
      },
      {
        name: 'Grey Goose 1500ml',
        price: '1045 RON',
        description: 'Large format premium vodka'
      },
      {
        name: 'Belvedere 700ml + 4 buc. Coca-Cola 250ml SAU Nectar (portocale/ mere/ cranberry) 1000ml',
        price: '650 RON',
        description: 'Premium vodka package with mixers'
      },
      {
        name: 'Belvedere 1750ml',
        price: '1050 RON',
        description: 'Large format premium vodka'
      },
      {
        name: 'Belvedere \'After Eight\' 1750ml',
        price: '1320 RON',
        description: 'Special edition premium vodka'
      },
      {
        name: 'Jameson 700ml',
        price: '260 RON',
        description: 'Irish whiskey'
      },
      {
        name: 'Jack Daniel\'s No.7 700ml + 4 buc. Coca-Cola 250ml SAU Nectar (mere/ cranberry) 1000ml',
        price: '370 RON',
        description: 'Classic whiskey package with mixers'
      },
      {
        name: 'Gentleman Jack 700ml + 4 buc. Coca-Cola 250ml SAU Nectar (mere/ cranberry) 1000ml',
        price: '650 RON',
        description: 'Premium whiskey package with mixers'
      },
      {
        name: 'Jack Daniel\'s Single Barrel 700ml 4 buc. Coca-Cola 250ml',
        price: '730 RON',
        description: 'Single barrel whiskey package'
      },
      {
        name: 'Woodford Reserved 700ml + 4 buc. Coca-Cola 250ml',
        price: '600 RON',
        description: 'Bourbon package with mixers'
      },
      {
        name: 'Jägermeister 700ml + 4 buc. Coca-Cola 250ml SAU Nectar (portocale/ mere/ cranberry) 1000ml',
        price: '270 RON',
        description: 'Herbal liqueur package with mixers'
      },
      {
        name: 'Bacardi Carta Blanca/ Spized 700ml + 4 buc. Coca-Cola 250ml SAU Nectar (portocale/ mere/ cranberry) 1000ml',
        price: '275 RON',
        description: 'Rum package with mixers'
      },
      {
        name: 'Bacardi 8 Year 700ml + 4 buc. Coca-Cola 250ml',
        price: '530 RON',
        description: 'Aged rum package with mixers'
      },
      {
        name: 'Mount Gay Black Barrel Rum 700ml + 4 buc. Coca-Cola 250ml',
        price: '530 RON',
        description: 'Premium rum package with mixers'
      },
      {
        name: 'Diplomatico Reserva Exclusiva 700ml + 4 buc. Coca-Cola 250ml',
        price: '700 RON',
        description: 'Premium rum package with mixers'
      },
      {
        name: 'Bombay Sapphire 700ml + 4 buc. Kinley 250ml',
        price: '308 RON',
        description: 'Gin package with tonic'
      },
      {
        name: 'The Botanist Gin 700ml + 4 buc. San Pellegrino Tonic premium 200ml',
        price: '700 RON',
        description: 'Premium gin package with tonic'
      },
      {
        name: 'Monkey 47 500ml + 4 buc. San Pellegrino Tonic premium 200ml',
        price: '700 RON',
        description: 'Premium gin package with tonic'
      },
      {
        name: 'Hendrick\'s 700ml + 4 buc. San Pellegrino Tonic premium 200ml',
        price: '700 RON',
        description: 'Premium gin package with tonic'
      },
      {
        name: 'Patron Silver Tequila 700ml',
        price: '800 RON',
        description: 'Premium tequila'
      },
      {
        name: 'Volcan Cristalino Tequila 700ml',
        price: '1050 RON',
        description: 'Premium cristalino tequila'
      }
    ]
  },
  champagne: {
    id: 'champagne',
    name: 'Champagne',
    description: '750-1500 ml, 12% - 12.5% vol.alc.',
    items: [
      {
        name: 'Laurent-Perrier Le Cuvée Brut 750ml',
        price: '671 RON',
        description: 'Classic brut champagne'
      },
      {
        name: 'Laurent-Perrier Cuvée Rosé Brut 750ml',
        price: '990 RON',
        description: 'Premium rosé champagne'
      },
      {
        name: 'Moët & Chandon Brut 750ml',
        price: '671 RON',
        description: 'Iconic brut champagne'
      },
      {
        name: 'Moët & Chandon Rosé Brut 750ml',
        price: '715 RON',
        description: 'Elegant rosé champagne'
      },
      {
        name: '4+1 Möet & Chandon Brut 750ml 5x 750ml',
        price: '2684 RON',
        description: 'Special package deal'
      },
      {
        name: '4+1 Möet & Chandon Rose 750ml 5x 750ml',
        price: '2860 RON',
        description: 'Special package deal'
      },
      {
        name: 'Moët & Chandon Magnum Brut 1500ml',
        price: '1045 RON',
        description: 'Large format brut champagne'
      },
      {
        name: 'Moët & Chandon Rosé Brut 1500ml',
        price: '1210 RON',
        description: 'Large format rosé champagne'
      },
      {
        name: 'Veuve Clicquot Brut 750ml',
        price: '660 RON',
        description: 'Classic brut champagne'
      },
      {
        name: 'Veuve Clicquot Rosé Brut 750ml',
        price: '715 RON',
        description: 'Premium rosé champagne'
      },
      {
        name: 'Dom Pérignon Brut 750ml',
        price: '2970 RON',
        description: 'Ultra premium brut champagne'
      },
      {
        name: 'Dom Pérignon Rosé Brut 750ml',
        price: '3630 RON',
        description: 'Ultra premium rosé champagne'
      },
      {
        name: 'Ferrari Maximum Blanc de Blancs 750ml',
        price: '365 RON',
        description: 'Italian sparkling wine'
      },
      {
        name: 'Ferrari Maximum Rose 750ml',
        price: '395 RON',
        description: 'Italian rosé sparkling wine'
      },
      {
        name: '4+1 Ferrari M. Blanc de Blancs 5x 750ml',
        price: '1460 RON',
        description: 'Special package deal'
      },
      {
        name: '4+1 Ferrari M. Rose 5x 750ml',
        price: '1580 RON',
        description: 'Special package deal'
      },
      {
        name: 'Ferrari M. Blanc de Blancs Magnum 1500ml',
        price: '525 RON',
        description: 'Large format sparkling wine'
      },
      {
        name: 'Ferrari M. Rose Magnum 1500ml',
        price: '590 RON',
        description: 'Large format rosé sparkling wine'
      },
      {
        name: 'Casa Coller Brut Prosecco 750ml',
        price: '132 RON',
        description: 'Italian prosecco'
      },
      {
        name: 'Casa Coller Rose Prosecco 750ml',
        price: '132 RON',
        description: 'Italian rosé prosecco'
      }
    ]
  },
  signatureCocktails: {
    id: 'signatureCocktails',
    name: 'Signature Cocktails',
    description: '160ml - Our exclusive creations',
    items: [
      {
        name: 'Lavender Delight',
        price: '35 RON',
        description: 'Bombay Sapphire / sirop lavender / schweppes kinley'
      },
      {
        name: 'The Gardener',
        price: '35 RON',
        description: 'Bombay Sapphire / sweet & sour / true ginger'
      },
      {
        name: 'Cuban Rose',
        price: '35 RON',
        description: 'Bacardi carta blanca / Bols Triplu Sec / Sirop Rose / sweet & sour / Sprite'
      },
      {
        name: 'Cinnamon Spark',
        price: '35 RON',
        description: 'Jack Daniel\'s / sirop cinnamon/ scortisoara / granini cranberry / sweet & sour'
      },
      {
        name: 'Pink Cloud',
        price: '35 RON',
        description: 'Malfi Gin Rosa / Sirop raspberry / Three Cents grapefruit / Sweet & Sour / bitter lime'
      },
      {
        name: 'Blood Fig Martini',
        price: '35 RON',
        description: 'Malfi Blood orange / Martini Rosso / Sweet & Sour / Three cents fig / bitter lime'
      },
      {
        name: 'Purple Crown',
        price: '35 RON',
        description: 'Mcqueen Violet Gin / Sirop raspberry / Sweet & Sour / Granini cranberry / lime bitter'
      },
      {
        name: 'Pornstar Martini',
        price: '35 RON',
        description: 'Vodka / Passion fruit puree / Sirop vanilla / Sour Mix / Prosecco'
      },
      {
        name: 'Mandarin Garden',
        price: '35 RON',
        description: 'Malfi Limone / Three cents mandarin / Sweet & Sour / Busuioc'
      }
    ]
  },
  cocktails: {
    id: 'cocktails',
    name: 'Cocktails',
    description: '160 ml / 25%-43% vol.alc',
    items: [
      {
        name: 'Sky',
        price: '30 RON',
        description: 'Bols Vodca / violet syrup / frizzante / sprite / gheata'
      },
      {
        name: 'Calabasa Coolers',
        price: '30 RON',
        description: 'Bols Vodca / Red Bull Yellow / sparkling water / lime'
      },
      {
        name: 'Paloma',
        price: '30 RON',
        description: 'Herradura tequila / grapefruit juice / sprite'
      },
      {
        name: 'El Diablo',
        price: '30 RON',
        description: 'Herradura tequila / blackberry liqueur / true ginger / sour mix'
      },
      {
        name: 'Strawberry & Mint Tom Collins',
        price: '30 RON',
        description: 'Bombay / strawberry syrup / sour mix / menta / gheata pisata'
      },
      {
        name: 'Raspberry Bramble',
        price: '30 RON',
        description: 'Bombay / raspberry syrup / sour mix / lime / gheata pisata'
      },
      {
        name: 'Lady Liberty',
        price: '30 RON',
        description: 'Jack Daniel\'s / Aperol / cinnamon syrup / sour mix / Red Bull Watermelon'
      },
      {
        name: 'Tom Collins',
        price: '30 RON',
        description: 'Bombay / sour mix / sparkling water'
      },
      {
        name: 'Mojito',
        price: '35 RON',
        description: 'Bacardi / sirop de zahar / lime / menta / soda / gheata pisata'
      },
      {
        name: 'Caipiroska',
        price: '30 RON',
        description: 'Bols Vodca / sirop de zahar / lime / gheata pisata'
      },
      {
        name: 'Fiero Tonic',
        price: '30 RON',
        description: 'Martini Fiero / tonic / gheata'
      }
    ]
  },
  longDrinks: {
    id: 'longDrinks',
    name: 'Long Drinks & Ice Teas',
    description: '160ml, 25%-43% vol.alc.',
    items: [
      {
        name: 'Whiskey Jack',
        price: '30 RON',
        description: 'cola / Red Bull / apple / sour / gheata'
      },
      {
        name: 'Ginger Monkey',
        price: '35 RON',
        description: 'Monkey Shoulder / ginger ale / portocale/ gheata'
      },
      {
        name: 'Tullamore Lemon & Lime ',
        price: '35 RON',
        description: 'Tullamore Dew / sprite / lime / gheata pisata'
      },
      {
        name: 'Grant\'s Rocks',
        price: '35 RON',
        description: 'Grant’s Triple Wood / orange twist / gheata'
      },
      {
        name: 'Hendrick\'s & Tonic',
        price: '45 RON',
        description: 'Hendrick’s / three cents tonic / castraveti / gheata'
      },
      {
        name: 'Glen fizzy',
        price: '65 RON',
        description: 'Glenfiddich 12 y.o. / suc de mere / sour mix / lime / gheata'
      },
      {
        name: 'Cuba Libre',
        price: '35 RON',
        description: 'Bacardi Spiced / cola / lime / gheata'
      },
      {
        name: 'Gin San Pellegrino Tonic',
        price: '30 RON',
        description: 'Bombay gin / tonic / gheata'
      },
      {
        name: 'Long Island Ice Tea',
        price: '35 RON',
        description: 'Bols Vodca / Bacardi / Bombay / triple sec / sour mix / cola / lime / gheata'
      },
      {
        name: 'Bullfrog',
        price: '35 RON',
        description: 'Bols Vodca / Bacardi / Bombay / blue curaçao liqueur / sour mix / Red Bull / lime / gheata'
      }
    ]
  },
  lowAlcoholCocktails: {
    id: 'lowAlcoholCocktails',
    name: 'Low-alcohol Cocktails',
    description: '160ml - 200ml, 8% - 17% vol.alc.',
    items: [
      {
        name: 'Fiero Spritz',
        price: '30 RON',
        description: 'Martini Fiero / sparkling wine / soda / gheata'
      },
      {
        name: 'Aperol Spritz',
        price: '30 RON',
        description: 'Aperol / sparkling wine / soda / gheata'
      },
      {
        name: 'Campari Spritz',
        price: '30 RON',
        description: 'Campari / sparkling wine / soda / gheata'
      },
      {
        name: 'Hugo',
        price: '35 RON',
        description: 'Sparkling wine / elderflower liqueur / soda / menta / lime / gheata'
      },
      {
        name: 'French 75',
        price: '30 RON',
        description: 'Bombay / sparkling wine / sugar syrup / sour mix'
      },
      {
        name: 'Sea Breeze',
        price: '30 RON',
        description: 'Peach liqueur / sparkling water / grapefruit juice'
      }
    ]
  },
  shooters: {
    id: 'shooters',
    name: 'Shooters',
    description: '20-30 ml, 15%-40% vol.alc.',
    items: [
      {
        name: 'Jägermeister Ice Cold',
        price: '13 RON',
        description: 'Chilled herbal liqueur'
      },
      {
        name: 'Kamikaze',
        price: '13 RON',
        description: 'Vodka / triple sec / lime'
      },
      {
        name: 'B52',
        price: '14 RON',
        description: 'Coffee liqueur / Irish cream / orange liqueur'
      },
      {
        name: 'Rikko shot',
        price: '13 RON',
        description: 'Special house shot'
      },
      {
        name: 'Herradura tequila',
        price: '20 RON',
        description: 'Premium tequila shot'
      },
      {
        name: 'Deer Blood',
        price: '12 RON',
        description: 'jagermeister, disaronno, sweet & sour, cranberry juice'
      },
      {
        name: '10 x Deer Blood',
        price: '100 RON',
        description: 'jagermeister, disaronno, sweet & sour, cranberry juice'
      }
    ]
  },
  classics: {
    id: 'classics',
    name: 'Classics & Martinis',
    description: '60ml - 120ml, 25% - 45% vol.alc.',
    items: [
      {
        name: 'Old Fashioned',
        price: '35 RON',
        description: 'Jack Daniel\'s / angostura bitters / brown sugar / orange peel / gheata'
      },
      {
        name: 'Godfather',
        price: '35 RON',
        description: 'Jack Daniel\'s / Disaronno Amaretto / gheata'
      },
      {
        name: 'Negroni',
        price: '35 RON',
        description: 'Campari / Martini Rosso / Bombay Sapphire / gheata'
      },
      {
        name: 'Negroni Sbagliato',
        price: '35 RON',
        description: 'Martini Bianco / Campari / sparkling water'
      },
      {
        name: 'Black Russian',
        price: '35 RON',
        description: 'Bols Vodca / Bols Coffee / gheata'
      },
      {
        name: 'Rusty Nail',
        price: '35 RON',
        description: 'Jack Daniel\'s / Drambuie / gheata'
      },
      {
        name: 'Cosmopolitan',
        price: '35 RON',
        description: 'Bols Vodca / triple sec / cranberry juice / lime'
      },
      {
        name: 'Margarita',
        price: '35 RON',
        description: 'Herradura / triple sec / sour mix'
      },
      {
        name: 'Dry Martini',
        price: '35 RON',
        description: 'Bombay / Dry Martini / masline'
      },
      {
        name: 'Daiquiri',
        price: '35 RON',
        description: 'Bacardi / sirop de zahar / lime juice'
      }
    ]
  },
  mocktails: {
    id: 'mocktails',
    name: 'Mocktails',
    description: '160 ml, 0% vol.alc.',
    items: [
      {
        name: 'Green Apple',
        price: '25 RON',
        description: 'apple juice / blue curaçao syrup / lime / gheata pisata'
      },
      {
        name: 'Wild Cherry',
        price: '25 RON',
        description: 'cherry juice / sirop de zahar / lime / gheata pisata'
      },
      {
        name: 'Grapefruit Mint',
        price: '25 RON',
        description: 'grapefruit juice / sirop de zahar / menta / tonic / lime / gheata pisata'
      },
      {
        name: 'Elimarys',
        price: '25 RON',
        description: 'pineapple juice / grenadine syrup / sour mix'
      },
      {
        name: 'Shirley Temple',
        price: '25 RON',
        description: 'True Ginger / grenadine syrup'
      },
      {
        name: 'Vibrant Summer',
        price: '25 RON',
        description: 'martini vibrante 50ml / tonic wather 150ml'
      },
      {
        name: 'Floral Delight',
        price: '25 RON',
        description: 'martini floreale 50ml / menta / grapefruit juice 150ml'
      }
    ]
  },
  whiskey: {
    id: 'whiskey',
    name: 'Whiskey',
    description: '40ml - 40% - 59% vol.alc.',
    items: [
      {
        name: 'Jack Daniel\'s Old No.7',
        price: '30 RON',
        description: 'Classic Tennessee whiskey'
      },
      {
        name: 'Gentleman Jack',
        price: '30 RON',
        description: 'Premium Tennessee whiskey'
      },
      {
        name: 'Jack Daniel\'s Single Barrel',
        price: '35 RON',
        description: 'Single barrel Tennessee whiskey'
      },
      {
        name: 'Jack Daniel\'s Honey',
        price: '30 RON',
        description: 'Honey-flavored Tennessee whiskey'
      },
      {
        name: 'Jack Daniel\'s Apple',
        price: '30 RON',
        description: 'Apple-flavored Tennessee whiskey'
      },
      {
        name: 'Jack Daniel\'s 100th Anniversary',
        price: '31 RON',
        description: 'Special anniversary edition'
      },
      {
        name: 'Jack Daniel\'s Bounded',
        price: '33 RON',
        description: 'Limited edition Tennessee whiskey'
      },
      {
        name: 'Jack Daniel\'s Triple Mash',
        price: '35 RON',
        description: 'Triple mash Tennessee whiskey'
      },
      {
        name: '7 Seals Sherry Wood',
        price: '58 RON',
        description: 'Single malt scotch whisky'
      },
      {
        name: 'Dewar\'s 12 y.o.',
        price: '28 RON',
        description: 'Scotch whisky'
      },
      {
        name: 'Aberfeldy 21 y.o.',
        price: '100 RON',
        description: 'Scotch whisky'
      },
      {
        name: 'Port Charlotte',
        price: '47 RON',
        description: 'Single malt scotch whisky'
      },
      {
        name: 'Glenfiddich 12yo',
        price: '60 RON',
        description: 'Single malt scotch whisky'
      },
      {
        name: 'Glenfiddich 15yo',
        price: '65 RON',
        description: 'Single malt scotch whisky'
      },
      {
        name: 'Glenfiddich 18yo',
        price: '106 RON',
        description: 'Single malt scotch whisky'
      },
      {
        name: 'Chivas Regal 12 y.o.',
        price: '30 RON',
        description: 'Scotch whisky'
      },
      {
        name: 'Chivas Regal 18 y.o.',
        price: '44 RON',
        description: 'Scotch whisky'
      },
      {
        name: 'Glenmorangie 10 y.o.',
        price: '34 RON',
        description: 'Scotch whisky'
      },
      {
        name: 'Bruichladdich The Classic Laddie',
        price: '45 RON',
        description: 'Scotch whisky'
      },
      {
        name: 'Octomore 7.1',
        price: '90 RON',
        description: 'Scotch whisky'
      },
      {
        name: 'Monkey Shoulder',
        price: '35 RON',
        description: 'Scotch whisky'
      },
      {
        name: 'Glendronach 8y',
        price: '33 RON',
        description: 'Scotch whisky'
      },
      {
        name: 'Tamdhu 10 y.o.',
        price: '33 RON',
        description: 'Single malt scotch whisky'
      },
      {
        name: 'Smokehead 10 y.o.',
        price: '33 RON',
        description: 'Single malt scotch whisky'
      },
      {
        name: 'Woodford Reserve',
        price: '30 RON',
        description: 'Bourbon whiskey'
      },
      {
        name: 'Elijah Craig 12 y.o.',
        price: '33 RON',
        description: 'Bourbon whiskey'
      },
      {
        name: 'Jameson',
        price: '30 RON',
        description: 'Irish whiskey'
      },
      {
        name: 'Jameson Black Barrel',
        price: '30 RON',
        description: 'Irish whiskey'
      },
      {
        name: 'Tullamore Dew',
        price: '32 RON',
        description: 'Irish whiskey'
      },
      {
        name: 'Amrut',
        price: '35 RON',
        description: 'Indian whisky'
      }
    ]
  },
  cognac: {
    id: 'cognac',
    name: 'Cognac & Brandy',
    description: '40ml, 40% vol.alc.',
    items: [
      {
        name: 'Rémy Martin V.S.O.P.',
        price: '50 RON',
        description: 'Premium cognac'
      },
      {
        name: 'Rémy Martin 1738 Acord Royal',
        price: '55 RON',
        description: 'Premium cognac'
      },
      {
        name: 'Rémy Martin X.O.',
        price: '160 RON',
        description: 'Ultra premium cognac'
      },
      {
        name: 'Metaxa Grand Fine',
        price: '50 RON',
        description: 'Greek brandy'
      },
      {
        name: 'Vinars Jidvei V.S.O.P',
        price: '25 RON',
        description: 'Romanian brandy'
      }
    ]
  },
  vodka: {
    id: 'vodka',
    name: 'Vodka',
    description: '40ml, 37%-40% vol.alc.',
    items: [
      {
        name: 'Bols Vodka',
        price: '25 RON',
        description: 'Classic vodka'
      },
      {
        name: 'Grey Goose Original / La Poire',
        price: '35 RON',
        description: 'Premium vodka'
      },
      {
        name: 'Grey Goose VX',
        price: '44 RON',
        description: 'Premium vodka'
      },
      {
        name: 'Taiga Shtof',
        price: '33 RON',
        description: 'Premium vodka'
      },
      {
        name: 'Belvedere',
        price: '35 RON',
        description: 'Premium vodka'
      },
      {
        name: 'Russian Standard',
        price: '30 RON',
        description: 'Premium Russian vodka'
      }
    ]
  },
  rum: {
    id: 'rum',
    name: 'Rum',
    description: '40ml, 35% - 45% vol.alc.',
    items: [
      {
        name: 'Malibu',
        price: '26 RON',
        description: 'Coconut rum'
      },
      {
        name: 'Bacardi Carta Blanca / Negra',
        price: '30 RON',
        description: 'Classic rum'
      },
      {
        name: 'Bacardi Spized',
        price: '30 RON',
        description: 'Spiced rum'
      },
      {
        name: 'Bacardi 8 Años',
        price: '30 RON',
        description: 'Aged rum'
      },
      {
        name: 'Mount Gay Black Barrel',
        price: '30 RON',
        description: 'Premium rum'
      },
      {
        name: 'Mount Gay Extra Old',
        price: '42 RON',
        description: 'Premium aged rum'
      },
      {
        name: 'Diplomatico Reserva Exclusiva',
        price: '35 RON',
        description: 'Premium rum'
      },
      {
        name: 'Diplomatico Mantuano',
        price: '35 RON',
        description: 'Premium rum'
      },
      {
        name: 'Diplomatico Planas',
        price: '35 RON',
        description: 'Premium rum'
      },
      {
        name: 'Zacapa 23 y.o.',
        price: '39 RON',
        description: 'Premium aged rum'
      },
      {
        name: 'Bumbu Original',
        price: '35 RON',
        description: 'Premium rum'
      },
      {
        name: 'Eminente',
        price: '36 RON',
        description: 'Premium rum'
      },
      {
        name: 'The Demon\'s Share 6Y',
        price: '33 RON',
        description: 'Premium aged rum'
      }
    ]
  },
  gin: {
    id: 'gin',
    name: 'Gin',
    description: '40ml, 40% - 47.5% vol.alc.',
    items: [
      {
        name: 'Bombay Sapphire',
        price: '30 RON',
        description: 'Classic London dry gin'
      },
      {
        name: 'Star of Bombay',
        price: '28 RON',
        description: 'Premium London dry gin'
      },
      {
        name: 'The Botanist Islay Dry Gin',
        price: '35 RON',
        description: 'Premium Scottish gin'
      },
      {
        name: 'Tanqueray',
        price: '30 RON',
        description: 'Classic London dry gin'
      },
      {
        name: 'G\'Vine Gin Floraison',
        price: '28 RON',
        description: 'Premium French gin'
      },
      {
        name: 'Monkey 47',
        price: '30 RON',
        description: 'Premium German gin'
      },
      {
        name: 'Hendrick\'s',
        price: '40 RON',
        description: 'Premium Scottish gin'
      },
      {
        name: 'Hendrick\'s Grand Cabaret',
        price: '79 RON',
        description: 'Ultra premium Scottish gin'
      }
    ]
  },
  tequila: {
    id: 'tequila',
    name: 'Tequila',
    description: '20ml, 35% - 40% vol.alc.',
    items: [
      {
        name: 'Herradura Silver / Reposado',
        price: '20 RON',
        description: 'Premium tequila'
      },
      {
        name: 'Patron Silver / Añejo',
        price: '22 RON',
        description: 'Premium tequila'
      },
      {
        name: 'Ilegal Mezcal Reposado',
        price: '28 RON',
        description: 'Premium mezcal'
      },
      {
        name: 'Volcan Blanco',
        price: '20 RON',
        description: 'Premium tequila'
      },
      {
        name: 'Volcan Cristalino',
        price: '33 RON',
        description: 'Premium cristalino tequila'
      }
    ]
  },
  bitter: {
    id: 'bitter',
    name: 'Bitter, Aperitif & Liqueurs',
    description: '40ml, 16% - 40% vol.alc',
    items: [
      {
        name: 'Jägermeister',
        price: '26 RON',
        description: 'Herbal liqueur'
      },
      {
        name: 'Jägermeister Manifest',
        price: '26 RON',
        description: 'Herbal liqueur'
      },
      {
        name: 'Jägermeister Scharf',
        price: '23 RON',
        description: 'Spicy herbal liqueur'
      },
      {
        name: 'Cointreau',
        price: '20 RON',
        description: 'Orange liqueur'
      },
      {
        name: 'Martini Riserva Speciale Bitter',
        price: '23 RON',
        description: 'Italian bitter'
      },
      {
        name: 'Martini Fierro',
        price: '23 RON',
        description: 'Italian aperitif'
      },
      {
        name: 'Limoncello',
        price: '29 RON',
        description: 'Italian lemon liqueur'
      },
      {
        name: 'Aperol',
        price: '26 RON',
        description: 'Italian aperitif'
      },
      {
        name: 'Campari',
        price: '26 RON',
        description: 'Italian bitter'
      },
      {
        name: 'Unicum',
        price: '26 RON',
        description: 'Hungarian herbal liqueur'
      }
    ]
  },
  anisse: {
    id: 'anisse',
    name: 'Anisse & Grappa',
    description: '20ml, 38% - 69% vol.alc',
    items: [
      {
        name: 'Vaccari Sambuca',
        price: '15 RON',
        description: 'Italian anise liqueur'
      },
      {
        name: 'Grande Absente',
        price: '15 RON',
        description: 'French absinthe'
      }
    ]
  },
  vermouth: {
    id: 'vermouth',
    name: 'Vermouth',
    description: '40ml -125ml, 16% - 40% vol.alc',
    items: [
      {
        name: 'Martini Bianco / Rosso / Extra Dry',
        price: '26 RON',
        description: 'Italian vermouth'
      },
      {
        name: 'Martini Riserva Speciale Ambrato / Rubino',
        price: '23 RON',
        description: 'Premium Italian vermouth'
      }
    ]
  },
  cordials: {
    id: 'cordials',
    name: 'Cordials & Irish Cream',
    description: '40ml, 17% - 40% vol.alc',
    items: [
      {
        name: 'Carolans',
        price: '22 RON',
        description: 'Irish cream liqueur'
      },
      {
        name: 'Southern Comfort',
        price: '22 RON',
        description: 'American liqueur'
      },
      {
        name: 'Drambuie',
        price: '22 RON',
        description: 'Scottish liqueur'
      },
      {
        name: 'Strega Cream',
        price: '22 RON',
        description: 'Italian cream liqueur'
      }
    ]
  },
  palinca: {
    id: 'palinca',
    name: 'Pãlincã',
    description: '20ml, 50% vol.alc.',
    items: [
      {
        name: 'Dom\' Profesor Clara / Bruna',
        price: '15 RON',
        description: 'Romanian traditional spirit'
      }
    ]
  },
  wineBottle: {
    id: 'wineBottle',
    name: 'Wine / Frizzante by the bottle',
    description: '750 ml, 11,5% - 15% vol.alc',
    items: [
      {
        name: 'Civ&Civ Lambrusco white/rose',
        price: '138 RON',
        description: 'Italian sparkling wine'
      },
      {
        name: 'Pirovano Wine red',
        price: '132 RON',
        description: 'Italian wine'
      },
      {
        name: 'Vinea by USAMV sauvignon blanc/ traminer roz',
        price: '121 RON',
        description: 'Romanian wine'
      },
      {
        name: 'Pirovano negroamaro red',
        price: '160 RON',
        description: 'Italian red wine'
      },
      {
        name: 'De Stefani white/rose',
        price: '132 RON',
        description: 'Italian wine'
      },
    ]
  },
  wineGlass: {
    id: 'wineGlass',
    name: 'Wine / Frizzante By The Glass',
    description: '150ml, 11,5% - 15% vol.alc.',
    items: [
      {
        name: 'Cuvee 56 Frizante White',
        price: '25 RON',
        description: 'Romanian sparkling wine'
      },
      {
        name: 'Civ & Civ Lambrusco White / Rose',
        price: '25 RON',
        description: 'Italian sparkling wine'
      },
      {
        name: 'Vinea by USAMV Sauvignon Blanc',
        price: '25 RON',
        description: 'Romanian white wine'
      },
      {
        name: 'Vinea by USAMV Traminer roz',
        price: '25 RON',
        description: 'Romanian rosé wine'
      },
      {
        name: 'Pirovano Beatrice red',
        price: '25 RON',
        description: 'Italian wine'
      },
      {
        name: 'De Stefani Rose',
        price: '25 RON',
        description: 'Italian wine'
      }
    ]
  },
  beer: {
    id: 'beer',
    name: 'Beer & Cider',
    description: '330 ml, 4,2% - 6,5% vol.alc.',
    items: [
      {
        name: 'Carlsberg',
        price: '18 RON',
        description: 'Danish lager'
      },
      {
        name: 'Corona',
        price: '25 RON',
        description: 'Mexican lager'
      },
      {
        name: 'Tuborg 0.0%',
        price: '18 RON',
        description: 'Non-alcoholic lager'
      },
      {
        name: 'Sommersby Cider apple, pear, blueberry, blackberry',
        price: '18 RON',
        description: 'Danish cider'
      }
    ]
  },
  softDrinks: {
    id: 'softDrinks',
    name: 'Soft Drinks',
    description: 'Refreshing non-alcoholic beverages',
    items: [
      {
        name: 'Coca Cola 250ml',
        price: '16 RON',
        description: 'Classic cola'
      },
      {
        name: 'Coca Cola Zero 250ml',
        price: '16 RON',
        description: 'Sugar-free cola'
      },
      {
        name: 'Fanta 250ml Orange',
        price: '16 RON',
        description: 'Orange soda'
      },
      {
        name: 'Sprite 250ml',
        price: '16 RON',
        description: 'Lemon-lime soda'
      },
      {
        name: 'Schweppes 250ml Kinley / Bitter Lemon / Mandarin',
        price: '16 RON',
        description: 'Premium mixers'
      },
      {
        name: 'Fuzetea Ice Tea 250ml Lemongrass / Peach',
        price: '16 RON',
        description: 'Refreshing iced tea'
      },
      {
        name: 'Granini 250ml mere / portocale',
        price: '16 RON',
        description: 'Premium fruit juices'
      },
      {
        name: 'True 250ml Ginger Ale',
        price: '20 RON',
        description: 'Premium ginger ale'
      },
      {
        name: 'San Pellegrino Tonic Premium',
        price: '22 RON',
        description: 'Premium tonic water'
      },
      {
        name: 'Dorna / Izvorul Alb 330ml',
        price: '14 RON',
        description: 'Natural mineral water'
      },
      {
        name: 'Evian 330ml',
        price: '20 RON',
        description: 'Premium mineral water'
      },
      {
        name: 'Three cents Grapefruit soda 200ml',
        price: '20 RON',
        description: 'Premium grapefruit soda'
      },
      {
        name: 'Three cents Fig leaf soda 200ml',
        price: '20 RON',
        description: 'Premium fig soda'
      },
      {
        name: 'Three cents Mandarin soda 200ml',
        price: '20 RON',
        description: 'Premium mandarin soda'
      },
      {
        name: 'Three cents Pineapple soda 200ml',
        price: '20 RON',
        description: 'Premium pineapple soda'
      },
      {
        name: 'Three cents Cherry soda 200ml',
        price: '20 RON',
        description: 'Premium cherry soda'
      },
      {
        name: 'Three cents Tonic water 200ml',
        price: '20 RON',
        description: 'Premium tonic water'
      }
    ]
  },
  energyDrinks: {
    id: 'energyDrinks',
    name: 'Energy Drinks',
    description: '250ml - Boost your energy',
    items: [
      {
        name: 'Red Bull',
        price: '19 RON',
        description: 'Classic energy drink'
      },
      {
        name: 'Red Bull Sugarfree',
        price: '19 RON',
        description: 'Sugar-free energy drink'
      },
      {
        name: 'Red Bull Watermelon',
        price: '19 RON',
        description: 'Watermelon flavored energy drink'
      },
      {
        name: 'Red Bull Tropical',
        price: '19 RON',
        description: 'Tropical flavored energy drink'
      },
      {
        name: 'Red Bull Estival',
        price: '19 RON',
        description: 'Summer edition energy drink'
      },
      {
        name: 'Red Bull Iced Vanilla Berry',
        price: '19 RON',
        description: 'Vanilla berry flavored energy drink'
      }
    ]
  },
  tobacco: {
    id: 'tobacco',
    name: 'Tobacco',
    description: 'British American Tobacco',
    items: [
      {
        name: 'La prețul maximal al zilei',
        price: 'Varies',
        description: 'Available at maximum daily price'
      }
    ]
  },
  diverse: {
    id: 'diverse',
    name: 'Diverse',
    description: 'Additional items and services',
    items: [
      {
        name: 'Alune 135g',
        price: '20 RON',
        description: 'Premium nuts'
      },
      {
        name: 'Orbit 14g',
        price: '15 RON',
        description: 'Chewing gum'
      },
      {
        name: 'Servetele buc',
        price: '7 RON',
        description: 'Napkins per piece'
      }
    ]
  }
};
